export default __webpack_public_path__ + "static/media/voucher-bg.2dbd3f1f.jpg";